import * as angular from "angular";
import * as _ from "lodash";
import * as PhoneFormat from "phoneformat.js";

angular
  .module('bringoz.admin.commons')
  .filter('bringozPhone', bringozPhone);

function bringozPhone(splitService) {
  return function bringozPhoneFilter(phoneNumber, defaultValue) {
    if (_.isUndefined(phoneNumber) || !phoneNumber) {
      return defaultValue;
    }

    const siteCountry = splitService.getCountryCode();
    const phoneCountry = PhoneFormat.countryForE164Number(phoneNumber)
    return _.isEqual(siteCountry, phoneCountry) ? PhoneFormat.formatLocal(phoneCountry, phoneNumber) : phoneNumber;
  };
}
